<template>
  <img src="@/assets/img/Icons/gallery/grey.svg" />
</template>

<script>
export default {}
</script>

<style></style>
